// extracted by css-extract-rspack-plugin
export default {"highlight":"HighlightExpression-module__highlight___nJ32l","block":"HighlightExpression-module__block___J1eMv","inline":"HighlightExpression-module__inline___AlgEh"};